import { Box, Button, Popover } from '@mui/material';
import { ReactComponent as GoogleIcon } from 'assets/icons/GoogleIcon.svg';
import { ReactComponent as ArrowIcon } from 'assets/img/ArrowDown.svg';
import { useState } from 'react';
import { ViettelCloudIAM } from './ViettelCloudIAM';

const MyCustomButton = ({
    login_sso_google,
    loginViettelCloud,
    loginSME
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '6px',
            overflow: 'hidden',
            border: theme => `1px solid ${theme.palette.secondary.main}`
        }}>
            <Button 
                variant='text'
                sx={{
                    margin: 'auto',
                    borderRight: theme => `1px solid ${theme.palette.secondary.main}`,
                    borderRadius: 'unset',
                    width: '-webkit-fill-available',
                    paddingTop: '7px',
                    paddingBottom: '7px',
                    '&:hover': {
                        backgroundColor: theme => theme.palette.primary[90]
                    }
                }}
                onClick={login_sso_google}
            >
                <GoogleIcon />
            </Button>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '34px',
                    '& path': { fill: '#A0616A' },
                    cursor: 'pointer',
                    borderLeft: 'unset',
                    width: '52px',
                    '&:hover': {
                        backgroundColor: theme => theme.palette.primary[90]
                    }
                }}
                onClick={handleClick}
            >
                <ArrowIcon />
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box sx={{ width: '350px', padding: '12px 20px' }}>
                    <Button variant='outlined' sx={{ width: '100%', height: '36px' }} onClick={() => { handleClose(); login_sso_google() }}>
                        <GoogleIcon />
                    </Button>
                    <Button variant='outlined' sx={{ width: '100%', height: '36px', marginTop: '20px' }} onClick={() => { handleClose(); loginViettelCloud() }}>
                        <ViettelCloudIAM />
                    </Button>
                    {/* <Button variant='outlined' sx={{ width: '100%', height: '36px', marginTop: '20px' }} onClick={() => { handleClose(); loginSME() }}>
                        <MySMEButton />
                    </Button> */}
                </Box>
            </Popover>
        </Box>
    )
}

export default MyCustomButton